import React, { useState } from 'react'
import { H3 } from '../../../AbstractElements'
import Typeahead from '../../../CommonElements/TypeAhead'
import { Col, Label, Row } from 'reactstrap'
import { Status } from '../../../Constant'
import { postDataWithToken } from '../../../Utils/restUtils'
import { storeFolloUp, storeFolloUpRole } from '../../../CommonURL'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import Transparentspinner from '../../Common/loader/Transparentspinner'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router'



const schema = yup.object().shape({
followupDate: yup
  .string()
  .required('Next followup date is required')
  .test('is-future-or-today', 'Followup date cannot be in the past', (value) => {
    if (!value) return false;

    const selectedDate = new Date(value);
    const today = new Date();

    // Remove time parts for fair date-only comparison
    selectedDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    return selectedDate >= today;
  }),



    remarks: yup
        .string()
        .required('Remarks are required')
        .min(2, 'Remarks must be at least 2 characters')
        .max(500, 'Remarks must not exceed 500 characters')
});

function AddFollowUp({leadId,authState,handleModal,handleGetFollowUps,getLeadDetails}) {
  
    const [loading,setloading]=useState(false)

    const navigate=useNavigate()

    const {
        register,
        handleSubmit,
        control,
        reset,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(schema),

    });

    const statusOptions = [{
        label: 'Pending',
        value: 'pending'
    },
    {
        label: 'Done',
        value: 'done'
    },
    ]

    const onSubmit = async (data) => {        
        setloading(true)
        const postRequest = {
            lead_id: leadId,
            followup_date: new Date(),
            next_followup_date: new Date(data?.followupDate),
            remarks:data?.remarks,
            status: 'pending',
            industry_type_id:getLeadDetails?.industry_type_id
        };
      
        const response = await postDataWithToken(
            storeFolloUp ,
            postRequest
        );

        if (response?.status === 200) {
            toast.success(response.data.message)
            handleModal()
            handleGetFollowUps()
            // getLeadDetails()
            

        } else if (
            response.status >= 400 &&
            response.status <= 405
        ) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (
            response.status >= 500 &&
            response.status <= 505
        ) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        } else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }

        setloading(false);
    }


    return (
        <div>
            {
                loading &&
                <Transparentspinner/>
            }
            <form onSubmit={handleSubmit(onSubmit)}>


                <Row className='mt-4'>
                    <Col md='6'>
                        <Label className="form-label" for="email">
                            Next Followup Date
                        </Label>
                        <span className="requireStar">*</span>
                        <input
                            className="form-control"
                            id="followupDate"
                            type="date"
                            {...register('followupDate')}

                        />
                        <p className="text-danger">{errors.followupDate?.message}</p>

                    </Col>

                    <Col md='6'>
                       
                        <Label className="form-label" for="email">
                            Remarks
                        </Label>
                        <span className="requireStar">*</span>
                        <textarea className="form-control"
                            name="remarks"
                            id="remarks"
                            rows="4"
                            placeholder="Enter your remarks..."
                            {...register('remarks')}


                        />
                        <p className="text-danger">{errors.remarks?.message}</p>
                    </Col>
                  

                    <div>
                    </div>
                </Row>
                <div className='mt-5'>
                    <button className='btn ' type='button' onClick={handleModal}>Cancel</button>
                    <button type='submit' className='btn btn-primary mx-2' >Save</button>
                </div>
            </form>
        </div>
    )
}

export default AddFollowUp